import { Reveal, Chapter } from "./shared";

const pains = [
  "A mood app gives you a vibe. It does not know what your Tuesday 9am actually looks like.",
  "SOURCECODED reads the rhythm you are already running, so you can choose better hours.",
];

export const Problem = () => (
  <section className="py-16 sm:py-24 lg:py-32 bg-[#F2F0EB] text-[#0B0B0C]" data-testid="problem-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="01" label="The problem" />
      </Reveal>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-7">
          <h2 className="h-heavy text-[32px] sm:text-5xl lg:text-6xl leading-[0.95]" data-testid="problem-headline">
            People keep making
            <br />
            <span className="text-[#8B8E93]">big decisions in their<br />worst hour of the day.</span>
          </h2>
        </Reveal>
        <div className="lg:col-span-5 flex flex-col justify-end gap-6">
          {pains.map((p, i) => (
            <Reveal key={p} delay={i * 0.12}>
              <div className="flex gap-5 items-start border-t border-[#0B0B0C]/15 pt-5">
                <span className="font-mono-brand text-xs text-[#FF4D0A] mt-1">/{String(i + 1).padStart(2, "0")}</span>
                <p className="text-[#55585E] leading-relaxed">{p}</p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.4}>
            <p className="text-[#0B0B0C] font-medium leading-relaxed border-l-2 border-[#FF4D0A] pl-5 mt-2" data-testid="problem-closer">
              Not prediction. Direction.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
